import { IEquipment } from '../../../../../equipment.types.ts'
import TextStatisticCard from '@/shared/Analytics/TextStatisticCard'
import useParameterValue from '../../../../../../../services/data/hooks/useParameterValue.ts'

interface IProps {
  equipmentId: IEquipment['id']
  title: string
}

const LiftFloorsCountCard = (props: IProps) => {
  const value = useParameterValue(props.equipmentId, 'floorsCountPrm')

  return (
    <TextStatisticCard title={props.title} loading={value.loading} width="100%" height="84px">
      <p className="text-heading-5">{value.value ? value.value : '—'}</p>
    </TextStatisticCard>
  )
}

export default LiftFloorsCountCard
